import { adminApiClient } from '../lib/apiClient';

const VARIANT_IMAGE_BASE_URL =
  process.env.REACT_APP_VARIANT_IMAGE_BASE_URL ||
  'http://localhost/papad/public/uploads/variants/';

function appendIfPresent(formData, key, value) {
  if (value !== undefined && value !== null && String(value).trim() !== '') {
    formData.append(key, String(value).trim());
  }
}

function extractVariants(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload?.data?.variants)) {
    return payload.data.variants;
  }

  if (Array.isArray(payload?.variants)) {
    return payload.variants;
  }

  return [];
}

export async function listAdminVariants(productId) {
  const formData = new FormData();
  appendIfPresent(formData, 'product_id', productId);
  const response = await adminApiClient.post('/admin/variants/list', formData);

  return {
    raw: response.data,
    items: extractVariants(response.data),
  };
}

export async function createAdminVariant(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'product_id', payload.product_id);
  appendIfPresent(formData, 'variant_name', payload.variant_name);
  appendIfPresent(formData, 'sku', payload.sku);
  appendIfPresent(formData, 'price', payload.price);
  appendIfPresent(formData, 'mrp', payload.mrp);
  appendIfPresent(formData, 'weight', payload.weight);

  if (payload.image instanceof File) {
    formData.append('image', payload.image);
  }

  const response = await adminApiClient.post('/admin/variants/create', formData);
  return response.data;
}

export async function updateAdminVariant(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'variant_id', payload.variant_id);
  appendIfPresent(formData, 'variant_name', payload.variant_name);
  appendIfPresent(formData, 'sku', payload.sku);
  appendIfPresent(formData, 'price', payload.price);
  appendIfPresent(formData, 'mrp', payload.mrp);
  appendIfPresent(formData, 'weight', payload.weight);
  appendIfPresent(formData, 'status', payload.status);

  if (payload.image instanceof File) {
    formData.append('image', payload.image);
  }

  const response = await adminApiClient.post('/admin/variants/update', formData);
  return response.data;
}

export async function deleteAdminVariant(variantId) {
  const formData = new FormData();
  appendIfPresent(formData, 'variant_id', variantId);

  const response = await adminApiClient.post('/admin/variants/delete', formData);
  return response.data;
}

export function buildVariantImageUrl(imageName) {
  if (!imageName) {
    return '';
  }

  if (/^https?:\/\//i.test(imageName)) {
    return imageName;
  }

  return `${VARIANT_IMAGE_BASE_URL}${imageName}`;
}
